import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const initialState = {
  limit: 10,
  files: [],
  fileLoading: false,
  showUpload: false,
  uploadFiles: [],
  quickLinks: [],
  questions: [],
  isCollapsed: false,
  isPlanSheet: false
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    _setLimit: (state, action) => {
      state.limit = action.payload;
    },
    _setFiles: (state, action) => {
      state.files = action.payload;
    },
    _updateFiles: (state, action) => {
      state.files.push(action.payload);
    },
    _updateFileById: (state, action) => {
      state.files = state.files?.map((item) => {
        if (item?.uuid === action.payload?.uuid) {
          return { ...item, ...action.payload }; // Merge the item with the new payload
        }
        return item; // Return the original item if no match
      });
    },
    _setFileLoading: (state, action) => {
      state.fileLoading = action.payload;
    },
    _setUploadFiles: (state, action) => {
      state.showUpload = true;
      state.uploadFiles.push(action.payload);
    },
    _resetUploadFiles: (state, action) => {
      state.showUpload = false;
      state.uploadFiles = [];
    },
    _setShowUpload: (state, action) => {
      state.showUpload = action.payload;
    },
    _setQuestions: (state, action) => {
      const uniqueQuestions = [];
      const seenIds = new Set();

      action.payload.forEach((question) => {
        if (!seenIds.has(question.id)) {
          seenIds.add(question.id);
          uniqueQuestions.push(question);
        }
      });

      state.questions = uniqueQuestions;
    },

    _removeQuestions: (state, action) => {
      const updateQuestions = state.questions.filter((item) => item.id !== action.payload.id);
      state.questions = updateQuestions;
    },
    _addQuestions: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.questions.push(...action.payload);
      } else if (typeof action.payload === 'object' && action.payload !== null) {
        state.questions.push(action.payload);
      }
    },
    _updateUploadFiles: (state, action) => {
      const formatData = state.uploadFiles.map((item) => {
        if (item?.uuid == action?.payload.uuid) {
          return { ...item, ...action?.payload };
        } else {
          return { ...item };
        }
      });
      state.uploadFiles = [...formatData];
    },
    _setQuickLinks: (state, action) => {
      state.quickLinks = action.payload;
    },
    _updateQuickLinks: (state, action) => {
      state.quickLinks.unshift(action.payload);
    },
    _removeQuickLinks: (state, action) => {
      const filterData = state.quickLinks.filter(
        (item) => item.id !== action.payload.id
      );
      state.quickLinks = [...filterData];
    },
    _setIsCollapsed: (state, action) => {
      state.isCollapsed = action.payload
    },
    _setIsPlanSheet: (state, action) => {
      state.isPlanSheet = action.payload
    }
  },
});

export const {
  _setLimit,
  _setFiles,
  _updateFiles,
  _updateFileById,
  _setFileLoading,
  _setUploadFiles,
  _updateUploadFiles,
  _resetUploadFiles,
  _setShowUpload,
  _setQuickLinks,
  _removeQuickLinks,
  _setQuestions,
  _removeQuestions,
  _addQuestions,
  _updateQuickLinks,
  _setIsCollapsed,
  _setIsPlanSheet
} = globalSlice.actions;

export default globalSlice.reducer;
